<script setup>
import { useI18n } from 'vue-i18n'
import { Link } from '@inertiajs/vue3'
import VendorPortalLayout from '@/Layouts/VendorPortalLayout.vue'
import TourCard from '@/Components/VendorPortal/TourCard.vue'

defineOptions({ layout: VendorPortalLayout })

const { t } = useI18n()

defineProps({
  tours: { type: Array, default: () => [] },
  kpis:  { type: Object, default: () => ({}) }
})
</script>

<template>
  <div class="dash-header">
    <h1 class="dash-title">
      {{ t('vendor_portal.dashboard.title') }}
    </h1>
    <Link
      href="/tours/new"
      class="add-btn"
    >
      + {{ t('vendor_portal.dashboard.add_tour') }}
    </Link>
  </div>

  <div class="kpi-row">
    <div class="kpi-card">
      <span class="kpi-label">{{ t('vendor_portal.dashboard.kpi.tours_count') }}</span>
      <span class="kpi-value">{{ kpis.tours_count }}</span>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">{{ t('vendor_portal.dashboard.kpi.pending_approval') }}</span>
      <span class="kpi-value">{{ kpis.pending_approval }}</span>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">{{ t('vendor_portal.dashboard.kpi.active_blackouts') }}</span>
      <span class="kpi-value">{{ kpis.active_blackouts }}</span>
    </div>
  </div>

  <div
    v-if="tours.length === 0"
    class="empty"
  >
    {{ t('vendor_portal.dashboard.empty') }}
  </div>

  <ul
    v-else
    class="grid"
  >
    <li
      v-for="tr in tours"
      :key="tr.id"
    >
      <TourCard :tour="tr" />
    </li>
  </ul>
</template>

<style scoped>
.dash-header { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin: 0 0 1rem; }
.dash-title { font-family: var(--font-display, var(--display)); font-size: 1.5rem; color: var(--ink); margin: 0; }
.add-btn {
  padding: 0.5rem 0.9rem; background: var(--accent); color: var(--accentInk);
  border-radius: var(--radius-button, 8px); text-decoration: none; font-weight: 600;
  font-size: 0.875rem; white-space: nowrap;
}
.kpi-row { display: grid; grid-template-columns: 1fr; gap: 0.75rem; margin-bottom: 1.5rem; }
@media (min-width: 640px) { .kpi-row { grid-template-columns: repeat(3, 1fr); } }
.kpi-card { background: var(--surface); border: 1px solid var(--line); border-radius: 0.75rem; padding: 1rem; display: grid; gap: 0.25rem; }
.kpi-label { font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted); }
.kpi-value { font-family: var(--font-display, var(--display)); font-size: 1.5rem; font-weight: 700; color: var(--ink); }
.empty { padding: 2.5rem 1rem; text-align: center; color: var(--muted); }
.grid { list-style: none; padding: 0; margin: 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); gap: 1rem; }
</style>
